import React, { useCallback } from 'react';

import { Option, Selector } from '../../spd/components/Selects/Selector';

export interface FormSelectOption {
  value: string;
  label: string;
}

interface FormSelectProps {
  value?: string | null;
  options: FormSelectOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
  withEmpty?: boolean;
}

export const FormSelect: React.FC<FormSelectProps> = ({
  value,
  options,
  onChange,
  disabled,
  withEmpty = true,
}) => {
  const displayValue = options.find(o => o.value === value)?.label ?? '';

  const provider = useCallback(
    (text: string) => {
      const filtered = text
        ? options.filter(o =>
            o.label.toLowerCase().includes(text.toLowerCase()),
          )
        : options;
      return Promise.resolve(filtered);
    },
    [options],
  );

  return (
    <Selector
      readOnly={disabled}
      creatable={false}
      clearable={withEmpty}
      value={displayValue}
      provider={provider}
      onChange={(option: Option) => onChange(option.value)}
    />
  );
};
